import React from "react";
import { connect } from "react-redux";
import get from "lodash/get";
import { WithLazy } from "@quintype/components";
import { string, number, object, any, bool } from "prop-types";

import DfpAd from "../../dfp-ad";

import "./ads.m.css";

const adKeys = {
  "home-page": "home",
  "story-page": "article",
  "section-page": "section",
  quint: "tq",
  "quint-hindi": "hq",
  fit: "fit",
};

const AdSlotBase = ({ id, publisherName, isHome, pageType, type = "desktop", isActivePlan, ...props }) => {
  if (isActivePlan) return null;

  let slotId = `${adKeys[publisherName]}_${type}_${adKeys[pageType]}_${id}`;

  if (isHome) {
    slotId = `${adKeys[publisherName]}_${type}_home_${id}`;
  }

  return (
    <WithLazy margin="300px">
      {() => (
        <div>
          <DfpAd adtype={slotId} {...props} />
        </div>
      )}
    </WithLazy>
  );
};

AdSlotBase.propTypes = {
  isActivePlan: number,
  id: string,
  pageType: string,
  publisherName: string,
  type: string,
  isHome: bool,
};

const mapStateToProps = (state) => ({
  isActivePlan: get(state, ["userReducer", "isActivePlan"], 0),
  pageType: get(state, ["qt", "pageType"]),
  publisherName: get(state, ["qt", "config", "publisher-attributes", "name"], null),
});

const AdSlot = connect(mapStateToProps, null)(AdSlotBase);

const AdFreeBase = ({ isActivePlan, children, member }) => {
  if (member && isActivePlan) return null;
  return <>{children}</>;
};

AdFreeBase.propTypes = {
  isActivePlan: number,
  children: any,
  member: object,
};

const mapStateToProps1 = (state) => ({
  isActivePlan: get(state, ["userReducer", "isActivePlan"], 0),
  member: state.member,
});

const AdFree = connect(mapStateToProps1, null)(AdFreeBase);

const proptypeSet1 = {
  mobile: string,
  desktop: string,
  story: object,
};

const proptypeSet2 = {
  id: string,
  story: object,
  type: string,
};

const QuintTopResponsiveContainer = ({ desktop, mobile }) => {
  return (
    <AdFree>
      <div styleName="quint-top-ad ad">
        <div styleName="desktop">
          <AdSlot id={desktop} type="desktop" />
        </div>
        <div styleName="mobile">
          <AdSlot id={mobile} type="mobile" />
        </div>
      </div>
    </AdFree>
  );
};

QuintTopResponsiveContainer.propTypes = proptypeSet1;

const QuintStickyContainer = ({ id }) => {
  return (
    <AdFree>
      <div styleName="">
        <AdSlot id={id} />
      </div>
    </AdFree>
  );
};

QuintStickyContainer.propTypes = proptypeSet2;

const Standard337x280Container = ({ id, type, story = {} }) => {
  const disableAds = get(story.metadata, ["story-attributes", "disableads", "0"], "no") === "yes";
  return disableAds ? null : (
    <AdFree>
      <div styleName="standard-337x280 ad" className="standard-337x280">
        <AdSlot id={id} story={story} type={type} />
      </div>
    </AdFree>
  );
};

Standard337x280Container.propTypes = proptypeSet2;

const Responisive337x280Container = ({ desktop, mobile, story = {} }) => {
  return (
    <AdFree>
      <div styleName="standard-337x280 ad" className="standard-337x280">
        <div styleName="desktop">
          <AdSlot id={desktop} story={story} type="desktop" />
        </div>
        <div styleName="mobile">
          <AdSlot id={mobile} story={story} type="mobile" />
        </div>
      </div>
    </AdFree>
  );
};

Responisive337x280Container.propTypes = proptypeSet1;

const Standard300x260Container = ({ id }) => {
  return (
    <AdFree>
      <div styleName="standard-300x260 ad" className="standard-300x260">
        <AdSlot id={id} />
      </div>
    </AdFree>
  );
};

Standard300x260Container.propTypes = proptypeSet2;

const Standard337x600Container = ({ id }) => {
  return (
    <AdFree>
      <div styleName="standard-337x600 ad" className="standard-337x600">
        <AdSlot id={id} type="desktop" />
      </div>
    </AdFree>
  );
};

Standard337x600Container.propTypes = proptypeSet2;

const StoryTopResponsiveContainer = ({ desktop, mobile, story }) => {
  const disableAds = get(story.metadata, ["story-attributes", "disableads", "0"], "no") === "yes";
  return disableAds ? null : (
    <AdFree>
      <div styleName="story-top-ad ad">
        <div styleName="desktop">
          <AdSlot id={desktop} story={story} type="desktop" />
        </div>
        <div styleName="mobile">
          <AdSlot id={mobile} story={story} type="mobile" />
        </div>
      </div>
    </AdFree>
  );
};

StoryTopResponsiveContainer.propTypes = proptypeSet1;

const StoryResponsiveContainer = ({ desktop, mobile, story }) => {
  const disableAds = get(story.metadata, ["story-attributes", "disableads", "0"], "no") === "yes";
  return disableAds ? null : (
    <AdFree>
      <div styleName="story-content ad">
        <div styleName="desktop">
          <AdSlot id={desktop} story={story} type="desktop" />
        </div>
        <div styleName="mobile">
          <AdSlot id={mobile} story={story} type="mobile" />
        </div>
      </div>
    </AdFree>
  );
};

const OutOfPageAd1 = () => {
  return (
    <AdFree>
      <AdSlot id="out_of_page_1" isHome />
    </AdFree>
  );
};

const OutOfPageAd2 = () => {
  return (
    <AdFree>
      <AdSlot id="out_of_page_2" isHome />
    </AdFree>
  );
};

const McanvasAd = () => {
  return (
    <AdFree>
      <AdSlot id="mcanvas" isHome />
    </AdFree>
  );
};

StoryResponsiveContainer.propTypes = proptypeSet1;

export {
  QuintTopResponsiveContainer,
  Standard337x280Container,
  Standard337x600Container,
  Standard300x260Container,
  StoryTopResponsiveContainer,
  StoryResponsiveContainer,
  Responisive337x280Container,
  AdSlot,
  AdFree,
  OutOfPageAd1,
  OutOfPageAd2,
  McanvasAd,
};
